export default __webpack_public_path__ + "static/media/H91A2152.787cca4c.jpg";